<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.2335 42.4672H25.7247C14.7999 42.4672 5.94873 51.3184 5.94873 62.2368V150.947C5.94873 160.221 13.4623 167.734 22.7359 167.734H27.9967V242.166H45.3471V167.734H51.2223C60.4959 167.734 68.0095 160.221 68.0095 150.947V62.2368C68.0095 51.3184 59.1583 42.4608 48.2335 42.4608V42.4672Z"
      class="fill-brand-300"
    />
    <path
      d="M188.445 140.022C222.469 140.022 250.051 112.44 250.051 78.416C250.051 44.3917 222.469 16.8096 188.445 16.8096C154.42 16.8096 126.838 44.3917 126.838 78.416C126.838 112.44 154.42 140.022 188.445 140.022Z"
      class="fill-secondary-500"
    />
    <path
      d="M213.885 143.389H69.6736V242.166H213.885V143.389Z"
      class="fill-brand-100"
    />
    <path
      d="M219.766 93.3024H92.3806V68.6432C92.3806 66.9152 90.979 65.52 89.2574 65.52H76.2846C74.5566 65.52 73.1614 66.9216 73.1614 68.6432V93.3024H63.8046C60.3102 93.3024 57.4814 96.1312 57.4814 99.6256V177.258C57.4814 180.752 60.3102 183.581 63.8046 183.581H219.773C223.267 183.581 226.096 180.752 226.096 177.258V99.6256C226.096 96.1312 223.267 93.3024 219.773 93.3024H219.766Z"
      class="fill-brand-500"
    />
    <path
      d="M117.795 137.296H70.1343V170.787H117.795V137.296Z"
      class="fill-brand-100"
    />
    <path
      d="M165.462 137.302H213.123V103.811H165.462V137.302Z"
      class="fill-brand-300"
    />
    <path
      d="M117.802 137.302H165.462V103.811H117.802V137.302Z"
      class="fill-brand-100"
    />
    <path
      d="M165.456 137.296H117.795V170.787H165.456V137.296Z"
      class="fill-brand-300"
    />
    <path
      d="M213.117 137.296H165.456V170.787H213.117V137.296Z"
      class="fill-brand-100"
    />
    <path
      d="M69.0654 27.5488C69.0654 19.9712 75.2094 13.8336 82.7806 13.8336C90.3518 13.8336 96.3934 19.9776 96.4958 27.5488C96.5982 34.9792 84.1246 55.4272 82.7806 58.2688C82.7614 58.3136 69.0654 35.1264 69.0654 27.5488Z"
      class="fill-brand-100"
    />
    <path
      d="M154.787 214.576V192.432C154.787 190.768 153.437 189.418 151.773 189.418H131.779C130.115 189.418 128.765 190.768 128.765 192.432V214.576H154.781H154.787Z"
      class="fill-brand-500"
    />
    <path
      d="M154.787 214.576H128.771V224.803H154.787V214.576Z"
      class="fill-secondary-500"
    />
    <path
      d="M196.695 214.576V192.432C196.695 190.768 195.344 189.418 193.68 189.418H173.687C172.023 189.418 170.672 190.768 170.672 192.432V214.576H196.688H196.695Z"
      class="fill-brand-500"
    />
    <path
      d="M196.694 214.576H170.678V224.803H196.694V214.576Z"
      class="fill-secondary-500"
    />
    <path
      d="M112.886 214.576H86.8704V224.803H112.886V214.576Z"
      class="fill-secondary-500"
    />
    <path
      d="M112.886 214.576V192.432C112.886 190.768 111.536 189.418 109.872 189.418H89.8784C88.2144 189.418 86.864 190.768 86.864 192.432V214.576H112.88H112.886Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Solar'
  }
</script>
